import axios from 'axios'

// Get all products (flat - para landing)
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/product`)
  return data
}

// Get all products grouped (para admin)
const getGrouped = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/product/grouped`)
  return data
}

// Get product by id (produto_periodo)
const getProductById = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/product/${id}`)
  return data
}

// Get product grouped by produto id (para edição com todos os períodos)
const getProductGroupedById = async (produtoId) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/product/grouped/${produtoId}`)
  return data
}

// Create product (produto + produto_periodo)
const create = async (platform, name, desc, active, periods) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/product`, {
    platform,
    name: name || null,
    desc: desc || null,
    active,
    periods: periods.map(p => ({
      periodName: String(p.periodName).trim(),
      dias: p.dias != null ? parseInt(p.dias) : null,
      description: p.description || null,
      price: p.price != null ? Number(p.price) : 0,
      priceUsd: p.priceUsd != null ? Number(p.priceUsd) : null,
      promotion: p.promotion || false,
      type: p.promotion ? (p.type || 'percent') : null,
      discount: p.promotion ? p.discount : null,
      expiration: p.promotion && p.expiration ? p.expiration : null,
      secondSubscriptionDiscount: p.secondSubscriptionDiscount != null ? parseInt(p.secondSubscriptionDiscount) : 0
    }))
  })
  return data
}

// Update product (produto_periodo)
const update = async (id, platform, name, desc, active, period) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/product/${id}`, {
    platform,
    name: name || null,
    desc: desc || null,
    active,
      period: {
        periodName: String(period.periodName).trim(),
        dias: period.dias != null ? parseInt(period.dias) : null,
        description: period.description || null,
        price: period.price != null ? Number(period.price) : null,
        priceUsd: period.priceUsd != null ? Number(period.priceUsd) : null,
        promotion: period.promotion || false,
        type: period.promotion ? (period.type || 'percent') : null,
        discount: period.promotion ? period.discount : null,
        expiration: period.promotion && period.expiration ? period.expiration : null,
        secondSubscriptionDiscount: period.secondSubscriptionDiscount != null ? parseInt(period.secondSubscriptionDiscount) : 0
      }
  })
  return data
}

// Adiciona período a um produto existente
const addPeriod = async (produtoId, period) => {
  const price = typeof period.price === 'number' ? period.price : parseFloat(String(period.price).replace(/\s/g, '').replace(/\./g, '').replace(',', '.')) || 0
  const priceUsd = period.priceUsd != null ? (typeof period.priceUsd === 'number' ? period.priceUsd : parseFloat(String(period.priceUsd).replace(/\s/g, '').replace(/\./g, '').replace(',', '.'))) : null
  const { data } = await axios.post(`${process.env.VUE_APP_API}/product/produto/${produtoId}/period`, {
    periodName: String(period.periodName || '').trim(),
    dias: period.dias != null ? parseInt(period.dias) : null,
    description: period.description || null,
    price,
    priceUsd: priceUsd != null && !isNaN(priceUsd) ? priceUsd : null,
    promotion: period.promotion || false,
    type: period.promotion ? (period.type || 'percent') : null,
    discount: period.promotion ? period.discount : null,
    expiration: period.promotion && period.expiration ? period.expiration : null,
    secondSubscriptionDiscount: period.secondSubscriptionDiscount != null ? parseInt(period.secondSubscriptionDiscount) : 0
  })
  return data
}

// Remove product (produto_periodo)
const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/product/${id}`)
  return data
}

export {
  getAll,
  getGrouped,
  getProductById,
  getProductGroupedById,
  create,
  update,
  addPeriod,
  remove
}
